import { useEffect } from 'react';
import { withAuthProvider } from '../auth';
import { initTrackingContext, initTracking } from './tracking';


const SegmentWrapper = (allData) => {
  const {isLoggedIn, me, data, hits } = allData;
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const userData = isLoggedIn && me ? {
      id: me.externalId || me.id,
      ...me
    } : null;

    initTrackingContext({
      user: userData,
      isLoggedIn
    });

    if (isLoggedIn && userData && window.analytics.identify) {
      window.analytics.identify(userData.id, {
        ...userData
      });
    } else if (window.analytics) {
      window.analytics.reset();
    }

    if (data) {
      if (Object.keys(data).length > 0) {
        const expertise = data.memberByUid.expertise.join(' ,');
        window.analytics.track('View Member', {
          member_name: data.memberByUid.firstName + ' ' + data.memberByUid.lastName,
          member_title: data.memberByUid.memberClassDescription,
          member_email: data.memberByUid.publicEmail,
          member_facility_name: data.memberByUid.primaryFacility.name,
          member_facility_address: data.memberByUid.primaryFacility.address.address1 + ' ' + data.memberByUid.primaryFacility.address.address2,
          member_facility_city: data.memberByUid.primaryFacility.address.city,
          member_section: data.memberByUid.section.name,
          member_expertise: expertise
        })
      }
    } else if (hits) {
      if (hits.length > 0) {
        window.analytics.track('View Facility', {
          facility_name: hits[0].facility_name,
          facility_city: hits[0].city,
          facility_id: hits[0].facility_id,
          facility_state: hits[0].state_name,
        })
      }
    }

    initTracking();

  }, [isLoggedIn, me, data, hits]);

  return null;
};

export default withAuthProvider(SegmentWrapper);